import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { defs } from 'src/app/defs';
import { UserService } from '../../user.service';
import { AuthService } from '../auth/auth.service';

@Component({
	selector: 'narwhalia-activation-modal',
	templateUrl: './activation-modal.component.html',
	styleUrls: ['./activation-modal.component.scss']
})
export class ActivationModalComponent implements OnInit {
	code: FormControl;
	activationForm: FormGroup;

	constructor(
		private userService: UserService,
		private dialogRef: MatDialogRef<ActivationModalComponent>,
		private authService: AuthService,
		@Inject(MAT_DIALOG_DATA) private data: any
	) {
		this.code = new FormControl('', [Validators.required]);
		this.activationForm = new FormGroup({
			code: this.code
		});
	}

	ngOnInit() {}

	sendEmail() {
		this.userService.resend(this.data.email).subscribe();
	}

	onSubmit() {
		const { code } = this.activationForm.value;
		this.authService.loginAfterActivation(code).subscribe(() => {
			localStorage.removeItem(defs.activationToken);
			this.dialogRef.close();
		});
	}

	close() {
		this.dialogRef.close();
	}
}
